export default __webpack_public_path__ + "static/media/background.f44e053f.png";